/*=========================================================================================
  File Name: moduleSpaceState.js
  Description: Space Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  ActiveStudentNotice: {
      title:'공지사항 없음',
      detail:'detail',
      id:0
  },
  studentNotices: [],
  studentNoticeSearchQuery: '',
  studentNoticeComments: [],

}
